export const strToMap = (str) => {
  let mapData = {}
  let listData = str.split(',')
  listData.forEach(function (item) {
    let listData1 = item.split('=')
    mapData[listData1[0]] = listData1[1]
  })
  return mapData
}

export const printDom = (domId) => {
  let pDom = document.getElementById(domId)
  let win = window.open('')
  win.document.write(pDom.outerHTML)
  win.print()
}

export const outPutExcelFile = (datas, fileName) => {
  let workbook = new window.Excel.Workbook()
  datas.forEach(function (item) {
    let worksheet1 = new window.Excel.Worksheet()
    worksheet1.addAllData(item.data)
    worksheet1.setName(item.sheetName)
    workbook.add(worksheet1)
  })
  workbook.setName(fileName)
  workbook.download()
}

export const clSort = (data, key) => {
  let dataType = []
  let newData = []
  data.forEach(function (item) {
    if (dataType.indexOf(item[key]) === -1) {
      dataType.push(item[key])
    }
  })
  dataType.forEach(function (item) {
    data.forEach(function (item2) {
      if (item2[key] === item) {
        newData.push([...item2])
      }
    })
  })
  return newData
}



// WEBPACK FOOTER //
// ./src/cllib.js